/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React from "react";
import { t } from "@superset-ui/core";
import PropTypes from "prop-types";
import Popover from "src/components/Popover";
import { decimal2sexagesimal } from "geolib";

import Label from "src/components/Label";
import { FormLabel } from "src/components/Form";
import TextControl from "../../TextControl";
import ControlHeader from "../../../ControlHeader";

export const DEFAULT_VIEWPORT = {
    latitude: 37.47958577725591,
    longitude: 126.88577721378743,
    zoom: 17,
    minZoom: 1,
    maxZoom: 22,
};

// const PARAMS = [t("longitude"), t("latitude"), t("zoom"), t("minZoom"), t("maxZoom")];
const PARAMS = [
    {
        key: "longitude",
        label: t("longitude"),
    },
    {
        key: "latitude",
        label: t("latitude"),
    },
    {
        key: "zoom",
        label: t("zoom"),
    },
    {
        key: "minZoom",
        label: t("minZoom"),
    },
    {
        key: "maxZoom",
        label: t("maxZoom"),
    },
];

const propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.shape({
        longitude: PropTypes.number,
        latitude: PropTypes.number,
        zoom: PropTypes.number,
        mimZoom: PropTypes.number,
        maxZoom: PropTypes.number,
    }),
    default: PropTypes.object,
    name: PropTypes.string.isRequired,
};

const defaultProps = {
    onChange: () => {},
    default: { type: "fix", value: 5 },
    value: DEFAULT_VIEWPORT,
};

export default class OlViewportControl extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
    }

    onChange(ctrl, value) {
        this.props.onChange({
            ...this.props.value,
            [ctrl]: value,
        });
    }

    renderTextControl(ctrl) {
        return (
            <div key={ctrl.key}>
                <FormLabel>{ctrl.label}</FormLabel>
                <TextControl
                    value={this.props.value[ctrl.key] || this.props.default[ctrl.key]}
                    onChange={this.onChange.bind(this, ctrl.key)}
                    isFloat
                />
            </div>
        );
    }

    renderPopover() {
        return <div id={`filter-popover-${this.props.name}`}>{PARAMS.map((ctrl) => this.renderTextControl(ctrl))}</div>;
    }

    renderLabel() {
        if (this.props.value.longitude && this.props.value.latitude) {
            return `${decimal2sexagesimal(this.props.value.longitude)} | ${decimal2sexagesimal(
                this.props.value.latitude
            )}`;
        }
        return "N/A";
    }

    render() {
        //     console.log("renderTextControl", this.props.value, this.props.default);
        return (
            <div>
                <ControlHeader {...this.props} />
                <Popover
                    container={document.body}
                    trigger="click"
                    placement="right"
                    content={this.renderPopover()}
                    title={t("Set map position and zoom")}
                >
                    <Label className="pointer">{this.renderLabel()}</Label>
                </Popover>
            </div>
        );
    }
}

OlViewportControl.propTypes = propTypes;
OlViewportControl.defaultProps = defaultProps;
